import style from './index.module.css'

import React from 'react'

import type { IndentedNestedGroup } from 'types/group'

import { Flex } from 'components/ds'
import Accordion from 'components/ui/accordion'

import { CheckboxContainer, CheckboxItem } from '../../components'

type AccordionCheckboxProps = {
  groups: IndentedNestedGroup[]
  handleSelection: (
    _checked: string | boolean,
    _group: IndentedNestedGroup,
    _event?: React.MouseEvent,
  ) => void
  searchValue: string
  onSelected: (_group: any) => boolean
  handleToggle: (_id: number) => void
}

const AccordionCheckbox: React.FC<AccordionCheckboxProps> = ({
  groups,
  handleSelection,
  searchValue,
  onSelected,
  handleToggle,
}) => {
  const checkBoxContent = (
    group: IndentedNestedGroup,
    indentedSpace: number,
  ) => {
    if (!group) return null
    return (
      <CheckboxContainer containerName={group.name}>
        <CheckboxItem
          item={group}
          onSelected={onSelected}
          handleSelection={handleSelection}
          searchValue={searchValue}
          indentedSpace={indentedSpace}
        />
      </CheckboxContainer>
    )
  }

  const renderGroup = (group: IndentedNestedGroup, indent = 0) => {
    const isEndGroup = !group?.folders?.length
    const indentedSpace = indent < 1 ? 0 : indent * 20

    if (!isEndGroup) {
      return (
        <Accordion
          key={group.id}
          titleClassName={style.AccordionTitle}
          contentClassName={style.AccordionContent}
          expanded={group.expanded}
          onTitleClick={() => handleToggle(group.id)}
          title={checkBoxContent(group, indentedSpace)}
          arrowType="arrow-down"
        >
          {group.folders?.map(child => renderGroup(child, indent + 1))}
        </Accordion>
      )
    }
    return checkBoxContent(group, indentedSpace)
  }

  return (
    <Flex direction="column" className={style.AccordionContainer}>
      {groups.map(group => renderGroup(group, group.indent))}
    </Flex>
  )
}

export default AccordionCheckbox
